var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPumping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .pumping-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:18;}\r\n        .pumping-st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:18;}\r\n        .pumping-st2{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:5.4774;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path1604",
    className: "pumping-st0",
    cx: 180,
    cy: 179.5,
    r: 159.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path31",
    className: "pumping-st1",
    points: "182.8,181.6 182.8,181.6 182.8,181.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1416",
    className: "pumping-st2",
    d: "M333.1,180.1L105.9,313.7l-2-263.5L333.1,180.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumping);
export default __webpack_public_path__ + "static/media/pumping.ba5a635e6cd1a1fc08ac8b8fb0594a7d.svg";
export { ForwardRef as ReactComponent };